<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="Receive Configuration"
        width="1000px"
        append-to-body
        top="10vh"
        custom-class="dialog-body-border-bottom"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="160px" class="pr50">
                <el-form-item label="Reception method：">
                    <el-button type="primary">Email</el-button>
                </el-form-item>
                <el-form-item label="Recipient's Email：" prop="direction_email" class="label-required">
                    <el-input v-model="formItem.direction_email" placeholder="Support for multiple email boxes, separate each email box with an English comma ','"></el-input>
                </el-form-item>
                <el-form-item label="CC's Email：" prop="email">
                    <el-input v-model="formItem.email" placeholder="Support for multiple email boxes, separate each email box with an English comma ','"></el-input>
                </el-form-item>
                <el-form-item label="Email Subject：" prop="title" class="label-required">
                    <el-input v-model="formItem.title" placeholder="Please enter the email subject" style="width:400px"></el-input>
                    <el-checkbox v-model="formItem.title_date" true-label="1" false-label="0" class="ml10">+ Yesterday's date</el-checkbox>
                </el-form-item>
                <el-form-item label="Email Body：" prop="body" class="label-required">
                    <WEditor ref="wEditor" :content="formItem.body"/>
                    <div class="remarks font12px mt10">
                        <p>Note：</p>
                        <div style="overflow: hidden">{__AUTO_FILL_LAST_WEEK_TOTAL__}</div>
                        <p class="remarks_text">This string indicates that the system displays the daily summary information of the corresponding fields specified by the template in the sheet. If this string is removed or the format of the string is inconsistent, the email body will not display the filled content</p>
                    </div>
                </el-form-item>
                <el-form-item label="Whether to send Excel：" prop="is_send" class="label-required">
                    <el-radio-group v-model="formItem.is_send">
                        <el-radio label="1">Send</el-radio>
                        <el-radio label="0">Do not Send</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Excel sending method：" prop="is_send" v-if="formItem.is_send=='1'" class="label-required">
                    <el-radio-group v-model="formItem.send_type">
                        <el-radio label="1">Send as a link
                            <el-tooltip class="item" placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>Add a download link in the body, which will prompt to download and save to the local or open online (depending on the browser's properties). The name of the downloaded zip file will take the email subject as its name. It is recommended to use this method to avoid attachment issues causing large emails and to enhance sending speed.</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="2">Send as an attachment
                            <el-tooltip class="item"  placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>Add Excel as an attachment in the email, if the attachment is compressed, the zip file name will take the email subject as its name. This method is not recommended as attachments may cause large emails that cannot be sent and affect loading and sending speed!</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Compress attachment：" prop="is_send"  v-if="formItem.is_send=='1'&&formItem.send_type=='2'" class="label-required">
                    <el-radio-group v-model="formItem.zip_send">
                        <el-radio label="0">Do not compress</el-radio>
                        <el-radio label="1">Compress</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac pt8">
            <el-button type="default" @click="handleClose" class="action-btn mr20">Cancel</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">Save</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex'
    import WEditor from '../../../components/editor';
    import { htmlBorder } from "@/utils";
    export default {
        name: "mailConfigModal",
        components:{
            WEditor,
        },
        props:{
            data:Object,
        },
        data(){
            const direction_email = (rule,value,callback)=>{
                if(!value){
                    callback(new Error("Please enter the recipient's email"));
                }else{
                    let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                    let mailArr = value.replace(/\;/g,",").split(',');
                    if(mailArr.every(item=>reg.test(item))){
                        callback();
                    }else{
                        callback(new Error('Please enter a valid email'));
                    }
                }
            };
            const email = (rule,value,callback)=>{
                if(!value) return callback();
                let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                let mailArr = value.replace(/\;/g,",").split(',');
                if(mailArr.every(item=>reg.test(item))){
                    callback();
                }else{
                    callback(new Error('Please enter a valid email'));
                }
            };
            const title = (rule,value,callback)=>{
                let reg = /[\[\]/\\*:\s?"<>|']/im;
                if(!value){
                    callback(new Error('Please enter an email subject'));
                }else if(value.length>40){
                    callback(new Error('Email subject cannot exceed 40 characters'));
                }else if(reg.test(value)){
                    callback(new Error('Email subject contains illegal characters: /\*:?"<>| [] and spaces'))
                }else{
                    callback();
                }
            };

            return {
                dialogVisible:false,
                formItem:{
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    title_date:'1',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                },
                rules:{
                    direction_email:[
                        { validator:direction_email ,trigger:'blur'}
                    ],
                    email:[
                        { validator:email, trigger:'blur'}
                    ],
                    title:[
                        {validator:title, trigger:'blur'}
                    ],
                },
            }
        },
        computed:{
            ...mapGetters([
                'name',
                'mobile',
                'email',
            ])
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem = {
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                    title_date:'1',
                };
                this.$refs.form.resetFields();
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let data = this.data||{};
                   let defaultBody = '<p>Dear all，Attached daily report, please review！</p><p></p><p></p><div>{__AUTO_FILL_LAST_WEEK_TOTAL__}</div><p> </p><p> </p><p>Best Regards<br>' +this.name + '<br>Wanka Huanju | Wanka Online Inc<br>Operations Department </p><p></p><p>Mobile：'+this.mobile +'<br>Email：' + this.email + '<br>Address: 4/F, Building No. B22, Universal Business Park , No.10 Jiuxianqiao Road, Chaoyang District, Beijing, China / 9th Floor, Pacific Insurance Building, Poly Innovator Square, No. 664 Huangpu Avenue Middle, Tianhe District, Guangzhou<br>Wanka Huanju：www.wankacn.com<br>Wanka Online Inc: www.wankaonline.com</p>';
                   this.formItem.direction_email = data.direction_email.replace(/\;/g,",");
                   this.formItem.email = data.email.replace(/\;/g,",");
                   this.formItem.title = data.title;
                   this.formItem.body = data.body||defaultBody;
                   this.formItem.is_send = data.is_send||'1';
                   this.formItem.send_type = data.send_type||'1';
                   this.formItem.zip_send = data.zip_send||'0';
                   this.formItem.title_date = data.title_date;
                   this.$refs.wEditor.setContent(data.body||defaultBody);
                });
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let mailCon = this.$refs.wEditor.getContent();
                        let mailText = this.$refs.wEditor.getContentText();
                        if(mailText.length<=0){
                            return this.$message.error('Please enter email content');
                        }
                        this.formItem.body = htmlBorder(mailCon);
                        this.$emit('save',{...this.formItem});
                        this.hideModal();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
        &.remarks_text {
            text-indent: 24px;
        }
    }
</style>
